module.exports = __webpack_public_path__ + "img/pxf_waxartforall.c5e11f1.png";